var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass:
        "custom-file d-flex align-content-center justify-content-between"
    },
    [
      _c("input", {
        staticClass: "custom-file-input",
        staticStyle: {
          "pointer-events": "none",
          position: "absolute",
          width: "0"
        },
        attrs: {
          name: "fileUpload",
          id: "fileUpload",
          type: "file",
          accept: ".doc,.docx,.pdf",
          required: ""
        },
        on: { change: _vm.fileChanged }
      }),
      _vm._v(" "),
      _vm.filename === ""
        ? _c("span", [_vm._v("Choose a file")])
        : _c("span", { domProps: { textContent: _vm._s(_vm.filename) } }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "button m-0",
          staticStyle: { "font-size": ".7em", "line-height": ".7" }
        },
        [_vm._v("Upload file (.pdf, .docx)")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12ca9994", { render: render, staticRenderFns: staticRenderFns })
  }
}